import { CoveoSearchHub } from '@lib/coveo/coveoConstants';
import { InitEngineOptions, createEngineModule } from './createEngineModule';

export const searchModule = createEngineModule(CoveoSearchHub.SEARCH);

const { initEngine, engine, resetEngine } = searchModule;

export { engine, initEngine, resetEngine };
export type { InitEngineOptions };
